export class StringHelper {
	public static replaceAll(input: string, s: any, r: any) {
		return input.replace(new RegExp(s, "g"), r);
	}

	public static replaceAllFromArray(input: string, sArr: any[], rArr: any[]) {
		let result = input;
		for (let i = 0; i < sArr.length; i++) {
			result = StringHelper.replaceAll(result, sArr[i], rArr[i]);
		}
		return result;
	}

	public static pad(input: string | number, length?: number, fillWith: string = "0"): string {
		if (length == null) {
			length = 2;
		}
		let val = input.toString();
		return (val.length < length) ? StringHelper.pad(`${fillWith}${val}`, length) : val;
	}

	public static getStringOrEmpty(input: string) {
		if (input == null) {
			return "";
		}
		return input;
	}

	public static fromArrayBuffer(arrayBuffer: ArrayBuffer): string {
		return String.fromCharCode.apply(null, new Uint16Array(arrayBuffer));
	}

	public static toArrayBuffer(input: string): ArrayBuffer {
		let buf = new ArrayBuffer(input.length * 2); // 2 bytes for each char
		let bufView = new Uint16Array(buf);
		for (let i = 0, strLen = input.length; i < strLen; i++) {
			bufView[i] = input.charCodeAt(i);
		}
		return buf;
	}

	public static getApproximateLengthInPx(value: string) {
		let ruler = $("<span>").attr("id", "rulerForApproximateLengthInPx").css("visibility", "hidden").css("white-space", "nowrap").html(value);
		$("body").append(ruler);
		let elem = $("#rulerForApproximateLengthInPx");
		let width = elem.width();
		elem.remove();

		return width;
	}

	public static isEvilString = (str: string) => {
		return str.split("")
			.map((chr) => chr.charCodeAt(0))
			.findIndex((chr) => chr === 8206);
	}

	public static readonly splitWildcasts = (val: string): string[] => {
		if (!val) {
			return [];
		}

		return val.split("*").filter((item) => item);
	}

	public static readonly toUpperCaseOrDefault = (val: string, defaultValue: string = null): string => {
		if (!val) {
			return defaultValue;
		}

		return val.toString().toUpperCase();
	}

	public static readonly toLowerCaseOrDefault = (val: string, defaultValue: string = null): string => {
		if (!val) {
			return defaultValue;
		}

		return val.toString().toLowerCase();
	}
}